export enum InsightVariant {
    NONE = 0,
    PRICE_ABOVE_AVERAGE = 1,
    HAS_OFFER_PROMOTIONS = 2,
    HAS_PROPERTY_PROMOTION = 3,
    PRICE_OPTIMAL = 4,
    PRICE_BELOW_AVERAGE = 5
}
export enum InsightVariant {
    NONE = 0,
    PRICE_ABOVE_AVERAGE = 1,
    HAS_OFFER_PROMOTIONS = 2,
    HAS_PROPERTY_PROMOTION = 3,
    PRICE_OPTIMAL = 4,
    PRICE_BELOW_AVERAGE = 5
}
